module.exports = __webpack_public_path__ + "img/png - student.490b0d18.png";